import { format } from 'date-fns'

import {
  CAMPAIGN_NAME_CONVENTION_OPTION,
  CAMPAIGN_NAME_OPTION,
  CONVENTION_NAME_DATE_FORMAT,
  CUSTOM_CAMPAIGN_NAME,
  EXPECTED_START_DATE,
  OPTIONAL_TAG,
  SHORT_CAMPAIGN_DESCRIPTION
} from './fields'

export const toPascalCase = (str = '') => {
  return str
    .split(' ')
    .map(word => (word.match(/^[A-Z]+$/) ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
    .join('')
}

export const formatConventionName = (values, selectedPartnership) => {
  const { rights_holder_name: rightsHolderName, partner_name: partnerName } = selectedPartnership

  const formattedExpectedStartDate = values[EXPECTED_START_DATE]
    ? format(values[EXPECTED_START_DATE], CONVENTION_NAME_DATE_FORMAT)
    : ''

  const conventionParts = [
    toPascalCase(rightsHolderName),
    toPascalCase(partnerName),
    toPascalCase(values[SHORT_CAMPAIGN_DESCRIPTION]),
    formattedExpectedStartDate,
    toPascalCase(values[OPTIONAL_TAG])
  ]

  return conventionParts.filter(Boolean).join('_')
}

export const formatCampaignName = (values, selectedPartnership) => {
  if (values[CAMPAIGN_NAME_OPTION] === CAMPAIGN_NAME_CONVENTION_OPTION) {
    return formatConventionName(values, selectedPartnership)
  } else {
    return values[CUSTOM_CAMPAIGN_NAME]
  }
}
